const VARIANT_ALIASES = {
  "404": "not_found",
  notfound: "not_found",
  missing: "not_found",
  "403": "forbidden",
  forbidden: "forbidden",
  unauthorized: "forbidden",
  load: "load_error",
  load_error: "load_error",
  error: "load_error",
  empty: "empty",
};

export const ERROR_STATE_VARIANTS = ["not_found", "forbidden", "load_error", "empty"];

export function httpStatusFromError(error) {
  if (error == null) return null;
  if (typeof error === "number") {
    return Number.isFinite(error) && error > 0 ? error : null;
  }
  const raw =
    error.response?.status ??
    error.status ??
    error.statusCode ??
    error.status_code;
  const status = Number(raw);
  return Number.isFinite(status) && status > 0 ? status : null;
}

export function errorStateVariantFromStatus(status) {
  if (status === 404) return "not_found";
  if (status === 403) return "forbidden";
  return "load_error";
}

export function errorStateVariantFromError(error) {
  if (typeof error === "string") {
    const alias = VARIANT_ALIASES[error.trim().toLowerCase()];
    if (alias) return alias;
  }
  return errorStateVariantFromStatus(httpStatusFromError(error));
}

export function normalizeErrorStateVariant(variant, fallback = "load_error") {
  if (variant == null || variant === "") return fallback;
  const alias = VARIANT_ALIASES[String(variant).trim().toLowerCase()];
  if (alias) return alias;
  return ERROR_STATE_VARIANTS.includes(variant) ? variant : fallback;
}
